// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"07d0dc0c9993180a55ed","811":"686bdd369bdbf5a43830"}[chunkId] + ".js";
};